(() => {
  const header = document.querySelector('[data-jhs-header]');
  const desktopNav = header?.querySelector('.jhs-header__desktop');
  const menu = header?.querySelector('[data-jhs-menu]');
  const dropdowns = [...(header?.querySelectorAll('.jhs-dropdown') || [])];
  const desktopMode = matchMedia('(min-width:1024px)');
  const hoverMode = matchMedia('(hover:hover) and (pointer:fine)');
  const dropdownStates = new Map(dropdowns.map(item => [item, {pointerInside:false,hoverOpened:false,suppressHover:false}]));
  const navigationOrigin = element => desktopNav?.contains(element) ? 'desktop' : menu?.contains(element) ? 'mobile' : null;
  let lastNavigationFocus = null;
  const closeDropdown = item => { item.open = false; dropdownStates.get(item).hoverOpened = false; };
  const closeMenus = () => { if (menu) menu.open = false; dropdowns.forEach(closeDropdown); };
  document.addEventListener('focusin', event => { lastNavigationFocus = navigationOrigin(event.target); });
  document.addEventListener('pointerdown', event => { if (!navigationOrigin(event.target)) lastNavigationFocus = null; });
  dropdowns.forEach(item => {
    const state = dropdownStates.get(item);
    const summary = item.querySelector('summary');
    item.addEventListener('pointerenter', event => {
      state.pointerInside = true;
      if (event.pointerType !== 'mouse' || !desktopMode.matches || !hoverMode.matches || state.suppressHover || item.open) return;
      dropdowns.filter(other => other !== item).forEach(closeDropdown);
      item.open = true;
      state.hoverOpened = true;
    });
    item.addEventListener('pointerleave', () => {
      state.pointerInside = false;
      state.suppressHover = false;
      if (!item.contains(document.activeElement)) closeDropdown(item);
    });
    item.addEventListener('focusout', event => {
      if (event.relatedTarget && item.contains(event.relatedTarget)) return;
      requestAnimationFrame(() => {
        if (!item.contains(document.activeElement)) {
          closeDropdown(item);
          state.suppressHover = state.pointerInside;
        }
      });
    });
    summary?.addEventListener('click', event => {
      event.preventDefault();
      const nextOpen = !item.open || state.hoverOpened;
      dropdowns.filter(other => other !== item).forEach(closeDropdown);
      item.open = nextOpen;
      state.hoverOpened = false;
      state.suppressHover = !nextOpen && state.pointerInside;
    });
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    const opened = menu?.open ? menu : dropdowns.find(item => item.open);
    if (!opened) return;
    event.preventDefault();
    dropdownStates.forEach(state => { state.suppressHover = state.pointerInside; });
    closeMenus();
    opened.querySelector('summary')?.focus({preventScroll:true});
  });
  document.addEventListener('click', event => {
    if (!(event.target instanceof Element)) return;
    if (!navigationOrigin(event.target)) lastNavigationFocus = null;
    if (!event.target.closest('[data-jhs-menu],.jhs-dropdown') || event.target.closest('a')) closeMenus();
  });
  desktopMode.addEventListener('change', () => {
    const active = document.activeElement;
    const focusWasLost = active === document.body || active === document.documentElement;
    const origin = navigationOrigin(active) || (focusWasLost ? lastNavigationFocus : null);
    closeMenus();
    dropdownStates.forEach(state => { state.pointerInside = false; state.suppressHover = false; });
    lastNavigationFocus = null;
    if (desktopMode.matches && origin === 'mobile') dropdowns[0]?.querySelector('summary')?.focus({preventScroll:true});
    else if (!desktopMode.matches && origin === 'desktop') menu?.querySelector('summary')?.focus({preventScroll:true});
  });
  if (header) {
    const measureHeader = () => document.documentElement.style.setProperty('--jhs-header-height', `${Math.ceil(header.getBoundingClientRect().height)}px`);
    new ResizeObserver(measureHeader).observe(header);
    measureHeader();
  }
  document.querySelectorAll('main .rte table').forEach(table => { if (table.closest('.jhs-table-scroll,.jhs-content-table')) return; const wrapper = document.createElement('div'); wrapper.className = 'jhs-table-scroll'; wrapper.tabIndex = 0; table.before(wrapper); wrapper.append(table); });
  const quick = document.querySelector('[data-jhs-quick]');
  const footer = document.querySelector('[data-jhs-footer]');
  if (quick) {
    const visible = element => { const rect = element.getBoundingClientRect(); return rect.width > 0 && rect.height > 0 && rect.bottom > 0 && rect.top < innerHeight; };
    const update = () => {
      const editing = document.activeElement?.matches('input,textarea,select');
      const primary = [...document.querySelectorAll('main .jhs-button,main [data-jhs-primary]')].some(visible);
      const hidden = scrollY < 480 || editing || primary || (footer && visible(footer));
      quick.hidden = Boolean(hidden); quick.inert = Boolean(hidden); quick.setAttribute('aria-hidden', String(Boolean(hidden)));
    };
    let queued = false; const schedule = () => { if (!queued) { queued = true; requestAnimationFrame(() => { queued = false; update(); }); } };
    addEventListener('scroll', schedule, {passive:true}); addEventListener('resize', schedule); document.addEventListener('focusin', schedule); document.addEventListener('focusout', schedule); update();
    document.querySelector('[data-jhs-top]')?.addEventListener('click', () => scrollTo({top:0,behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'auto':'smooth'}));
  }
})();
